import fetch from 'isomorphic-fetch';
import Config from '../config';

export const SET_ITEM_VIEW = 'SET_ITEM_VIEW';
export function setItemView(itemView){
	return { type: SET_ITEM_VIEW, itemView }
}

export const REQUEST_POSTS = 'REQUEST_POSTS';
export function requestPosts(filters){
	return { type: REQUEST_POSTS, filters }
}

export const RECEIVE_POSTS = 'RECEIVE_POSTS';
export function receivePosts(rawPosts){
	let items = rawPosts.map(Config.mapRawJSONToObject).filter(r => r);
	return { type: RECEIVE_POSTS, items	}
}

export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES';
export function setTotalPages(totalPages){
	return { type: SET_TOTAL_PAGES, totalPages: parseInt(totalPages, 10) };
}

export const SET_STATIC_HTML = 'SET_STATIC_HTML';
export function setStaticHtml(html){
	return { type: SET_STATIC_HTML, html };
}

export function fetchPosts(){
	return function(dispatch, getState){
		dispatch(setItemView(Config.itemView));
		dispatch(requestPosts());

		return fetch(Config.getAPIEndpoint(getState()))
			.then(response => {
				dispatch(setTotalPages(response.headers.get('X-WP-TotalPages')));
				return response.json();
			})
			.then(json => {
				return dispatch(receivePosts(json));
			})
	}
}
